import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { mdCardSx } from "./mdTheme";

/** Compact page header — matches ExDashboard ContractTypeFilterBar scale */
const HeroFilterBar = ({ title = "Fleet Service Dashboard", subtitle, controls }) => (
  <Paper
    elevation={0}
    component="header"
    sx={{
      ...mdCardSx,
      alignItems: "center",
      border: "1px solid #e3e5ee",
      boxShadow: "none",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 1.5,
      height: "auto",
      justifyContent: "space-between",
      overflow: "visible",
      px: 1.75,
      py: 1.25,
    }}
  >
    <Box sx={{ minWidth: 0, pr: 1 }}>
      <Typography
        component="h1"
        sx={{
          color: "#1b1f4b",
          fontSize: 16,
          fontWeight: 700,
          letterSpacing: "-0.01em",
          lineHeight: 1.25,
          m: 0,
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          sx={{
            color: "#646a8a",
            fontSize: 12,
            fontWeight: 500,
            lineHeight: 1.35,
            m: 0,
            mt: 0.25,
            maxWidth: 620,
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
    {controls ? (
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
        spacing={1}
        sx={{ ml: "auto" }}
      >
        {controls}
      </Stack>
    ) : null}
  </Paper>
);

export default HeroFilterBar;
